
'use strict';

import objectAssign from 'object-assign';
import Cookies from 'cookies-js';

import 'fontfaceobserver';
const FontFaceObserver = window.FontFaceObserver;


/***
 * non specific methods
 *
 */
const getFontKey = (fontName) => {
    return fontName.toLowerCase().replace(' ', '-');
};

const getFontCookieKey = (cookieKey, fontName) => {
    return `${cookieKey}_${getFontKey(fontName)}`;
};

const addLoadedFontClassName = (fontName) => {
    // console.log('fontName', fontName);
    let fontKey = getFontKey(fontName);
    let className = `webfont-${fontKey}--loaded`;
    document.documentElement.classList.add(className);
};


/***
 * factory method
 *
 */
const webFontManager = (fonts = [], cookieKey = 'mysite_webfont') => {
    let props = {
        webfonts: fonts,
        cookieKey: cookieKey
    };

    return objectAssign({}, {

        props,

        addLoadedFontClassName,

        getFontCookieKey,

        inactivateFontCookie(fontName) {
            if (!Cookies.enabled) {
                return;
            }

            // console.log(`${fontName} is NOT available :(`);
            Cookies.set(this.getFontCookieKey(this.props.cookieKey, fontName), 'false');
        },

        activateFontCookie(fontName) {
            if (!Cookies.enabled) {
                return;
            }

            // console.log(`${fontName} is available!`);
            Cookies.set(this.getFontCookieKey(this.props.cookieKey, fontName), 'true');
        },

        createFontObserver(fontName) {
            let observer = new FontFaceObserver(fontName, {});

            observer.check().then(() => {
                this.activateFontCookie(fontName);
                this.addLoadedFontClassName(fontName);
            }, () => {
                this.inactivateFontCookie(fontName);
            });
        },

        configureWebfonts() {
            // console.log('configureWebfonts', this);

            this.props.webfonts.forEach((fontName) => {
                this.createFontObserver(fontName);
            });
        }

    });
};


export default webFontManager;




/** WEBPACK FOOTER **
 ** ./src/scripts/client/utilities/webFontManager.js
 **/